import {
  Avatar,
  Box,
  Card,
  CardContent,
  Chip,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import * as Redux from 'react-redux';
import { GREEN_COLOR } from '../../../../../constants/ColorsConst';
import { getFilesArchivos } from '../../../../archivos/HelpersArchivos';

const FamiliaresEstudiantesComponent = () => {
  const familiaresStore = Redux.useSelector((state) => state.familiares);

  return familiaresStore.all.length === 0 ? (
    <Chip
      sx={{ m: 2 }}
      color="primary"
      label="No tiene representantes asignado"
    />
  ) : (
    <Grid container spacing={2} sx={{ p: 2 }}>
      {familiaresStore.all.map((el, index) => {
        return (
          <Grid item xs={12} md={4}>
            <Card sx={{ border: el.titular && `solid 1px ${GREEN_COLOR}` }}>
              <CardContent>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <Avatar
                    alt={el.familiar.perfil.pnombre}
                    src={
                      el.familiar.perfil.avatar
                        ? getFilesArchivos(el.familiar.perfil.avatar)
                        : `static/images/${
                            el.familiar.perfil.gender
                              ? 'userf.png'
                              : 'userm.png'
                          }`
                    }
                    sx={{ width: 120, height: 120, mb: 1 }}
                  />
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 'bold',
                    }}
                  >
                    {el.familiar.perfil.pnombre} {el.familiar.perfil.papellido}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 'bold',
                    }}
                  >
                    {el.familiar.perfil.tipoDni}-{el.familiar.perfil.dni}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: 'bold',
                    }}
                  >
                    {el.parentesco}
                  </Typography>
                  {el.titular && (
                    <Chip
                      color="success"
                      label="TITULAR"
                      sx={{ fontWeight: 'bold' }}
                    />
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default FamiliaresEstudiantesComponent;
